import React, { useRef, useEffect } from 'react';

const Camera = ({ setShowCamera, setBase64Image }) => {


    const videoRef = useRef(null);
    let stream = null;

    useEffect(() => {

        startCamera();
        console.log('camera mounted');
        return () => {
            // Clean up resources when the component unmounts
            stopCamera();
            console.log('camera unmounted');
        };

    }, []);

    const startCamera = async () => {
        try {
            stream = await navigator.mediaDevices.getUserMedia({ video: true });
            videoRef.current.srcObject = stream;
        } catch (error) {
            console.error('Error accessing camera:', error);
        }
    };

    const stopCamera = () => {
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());

            try {
                videoRef.current.srcObject = null;
            } catch (error) {
                console.error('error stopping camera ', error);
            }


        }
        setShowCamera(false);
    };
    const capture = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;
        context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        const imageSrc = canvas.toDataURL('image/jpeg');
        console.log(imageSrc); // You can use or save the image source here

        setBase64Image(imageSrc);
        stopCamera();

    };

    return (
        <div>
            {/* <button onClick={startCamera}>Start Camera</button>
            <button onClick={stopCamera}>Stop Camera</button> */}

            <video ref={videoRef} autoPlay style={{ maxWidth: '100%' }} />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>


                {/* <button onClick={stopCamera}>Cancel</button> */}
                <button className='captureButton'
                    onClick={capture}>
                    <i className='fa fa-camera'></i>
                </button>
            </div>
        </div>
    );

}

export default Camera;
